import { showNotification } from "components/v2/notification/notification";
import { APP_VERSION } from "constants/v2/appConstants";
import amplitude from "externals/amplitude";
import { noop } from "lodash";
import { useContext, useEffect } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { updateProgressPercent } from "store/clipList/slice";

import { SocketContext } from "../../../../context/socket";

const WebSocketGenerateHighlight = ({
  clipListId,
  reloadFunc,
  updateProgressPercent,
  isDragDropHL = false,
  showToastNotification = false,
  handleShowToastNotification = noop,
  closeStepperNotification = noop,
  currentStepRef,
  autoCloseTimerRef,
  stepperTotalSteps = 7,
  updateStatus = false,
}) => {
  const { webhookSocket } = useContext(SocketContext);

  useEffect(() => {
    if (!clipListId) return;

    webhookSocket.on(`createPreview${clipListId}`, (data) => {
      updateProgressPercent({
        clipListId,
        progressPercent: data.progressPercent,
        status: updateStatus ? data.status : null,
      });

      if (isDragDropHL) {
        if (data.status === "Completed" || data.status === "Failed") {
          reloadFunc(data.status === "Completed");
        }
      } else {
        if (data.status === "Completed") {
          reloadFunc({ silentReload: true });
          amplitude.logEvent("highlight_generation_completed", {
            clipListId,
            version: APP_VERSION.V2,
          });
          currentStepRef.current = Math.min(currentStepRef.current + 1, stepperTotalSteps);
          if (showToastNotification) {
            handleShowToastNotification(data.message || "Highlight generated successfully.", clipListId);
            autoCloseTimerRef.current = setTimeout(() => closeStepperNotification(clipListId), 5000);
          }
        } else if (data.status === "Failed") {
          closeStepperNotification(clipListId);
          showNotification({
            type: "error",
            message: data.message || "Unable to create the highlight. Please try generating it again.",
          });
        } else if (data.status === "InProgress" && data.message) {
          currentStepRef.current = Math.min(currentStepRef.current + 1, stepperTotalSteps);
          if (showToastNotification) {
            handleShowToastNotification(data.message, clipListId);
          }
        }
      }
    });

    return () => {
      webhookSocket.off(`createPreview${clipListId}`);
      if (autoCloseTimerRef?.current) {
        clearTimeout(autoCloseTimerRef.current);
      }
    };
  }, [
    clipListId,
    reloadFunc,
    webhookSocket,
    updateProgressPercent,
    isDragDropHL,
    showToastNotification,
    handleShowToastNotification,
    closeStepperNotification,
    currentStepRef,
    autoCloseTimerRef,
    stepperTotalSteps,
    updateStatus,
  ]);

  return null;
};

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = { updateProgressPercent };

export default connect(mapStateToProps, mapDispatchToProps)(WebSocketGenerateHighlight);
